import { DropdownItem } from 'flowbite-react';
import { useState } from 'react';

import { AbbCaretRight } from '@/assets/icons/components/abb-caret-right';
import { useTheme } from '@/modules/utils/custom-hooks/use-theme';
import { Paragraph } from '@/ui-components/paragraph/paragraph';

export const NestedDropdownItem = ({
  label,
  items,
  onClick
}: {
  label: string;
  items: { value: string; label: string }[];
  onClick?: (value: string) => void;
}) => {
  const { isDarkTheme } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <div className='relative px-4 py-3 w-full text-left' onMouseEnter={() => setOpen(true)}>
      <DropdownItem onMouseDown={(e) => e.stopPropagation()} className='flex justify-between items-center gap-3 !p-0'>
        <Paragraph variant='text-sm'>{label}</Paragraph>
        <AbbCaretRight size={20} fill={isDarkTheme ? '#f1f1f1' : '#1f1f1f'} />
      </DropdownItem>

      {open && (
        <div className='absolute bottom-0 left-full translate-x-1 z-40 min-w-36 rounded-lg bg-white dark:bg-gray-700 dark:border-none shadow-dropdown border max-h-48 overflow-auto scrollbar-rounded '>
          {items.map((sub) => (
            <DropdownItem key={sub.value} onClick={() => onClick?.(sub.value)} className='p-3'>
              <span className='text-sm'>{sub.label}</span>
            </DropdownItem>
          ))}
        </div>
      )}
    </div>
  );
};
